document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.collection-products').forEach(collection => {
    const track = collection.querySelector('.product-track');
    const prevBtn = collection.querySelector('.leftArrow');
    const nextBtn = collection.querySelector('.rightArrow');
    if (!track || !prevBtn || !nextBtn) return;

    const items = Array.from(track.children).filter(n => n.nodeType === 1);
    if (!items.length) return;

    const getPaddingLeft = () => parseFloat(getComputedStyle(track).paddingLeft) || 0;
    const getMaxScrollLeft = () => Math.max(0, Math.round(track.scrollWidth - track.clientWidth));

    function getFirstVisibleIndex() {
      const scrollLeft = Math.round(track.scrollLeft);
      for (let i = 0; i < items.length; i++) {
        const itemStart = Math.round(items[i].offsetLeft);
        const itemEnd = itemStart + Math.round(items[i].offsetWidth);
        if (itemEnd > scrollLeft) return i;
      }
      return items.length - 1;
    }

    function getLastVisibleIndex() {
      const rightEdge = track.scrollLeft + track.clientWidth - 1;
      for (let i = items.length - 1; i >= 0; i--) {
        if (items[i].offsetLeft < rightEdge) return i;
      }
      return 0;
    }

    function scrollToIndex(index) {
          index = Math.max(0, Math.min(items.length - 1, index));
          const maxScrollLeft = getMaxScrollLeft();

          let left;
          // If it's the final item, go to the very end
          if (index === items.length - 1) {
            left = maxScrollLeft;
          } else {
            // Normal behaviour: align item to left edge (account for track padding)
            left = Math.max(0, Math.round(items[index].offsetLeft - getPaddingLeft()));
            // But never exceed the true max scroll
            left = Math.min(left, maxScrollLeft);
          }

          // Smooth scroll with fallback
          if ('scrollBehavior' in document.documentElement.style) {
            track.scrollTo({ left, behavior: 'smooth' });
          } else {
            track.scrollLeft = left;
          }
        }

    prevBtn.addEventListener('click', () => {
      const first = getFirstVisibleIndex();
      scrollToIndex(first > 0 ? first - 1 : 0);
    });

    nextBtn.addEventListener('click', () => {
      const first = getFirstVisibleIndex();
      scrollToIndex(Math.min(items.length - 1, first + 1));
    });

    function updateButtons() {
      const first = getFirstVisibleIndex();
      const last = getLastVisibleIndex();
      prevBtn.disabled = first <= 0;
      nextBtn.disabled = last >= items.length - 1;
    }

    track.addEventListener('scroll', () => requestAnimationFrame(updateButtons));
    window.addEventListener('resize', () => requestAnimationFrame(updateButtons));

    updateButtons();
  })
});










// Dynamic announcement bar: height observer + seamless scrolling marquee
document.addEventListener("DOMContentLoaded", () => {
  const stickyHeaderEl = document.querySelector("sticky-header");
  if (stickyHeaderEl) {
    const setHeaderHeight = () => {
      document.documentElement.style.setProperty("--header-height", stickyHeaderEl.offsetHeight + "px");
    };
    if (window.ResizeObserver) {
      new ResizeObserver(setHeaderHeight).observe(stickyHeaderEl);
    }
    setHeaderHeight();
  }

  // Announcement marquee: hold a constant glide speed regardless of message
  // count or viewport width, by deriving the animation duration from the
  // measured track width. The Liquid renders .brimm-marquee__track (animated in
  // custom.css via --marquee-duration); this only tunes that duration.
  //
  // NB: the previous setupBrimmMarquee() that built its own .brimm-marquee-outer
  // DOM was removed here — it was superseded by the Liquid .brimm-marquee__track
  // and conflicted with it (that's the same reason it was already disabled). Its
  // one useful idea, duration = distance / speed, is reused below on the real track.
  //
  // Speed: the demo runs ~28px/s (1246px / 45s). (The earlier mobile
  // "sluggishness" was the flex-shrink track-collapse bug, not this value —
  // fixed in custom.css.) 40 reads a touch livelier than the demo; drop to 28
  // to match the demo exactly. Adjust this one number to taste.
  const BRIMM_MARQUEE_SPEED = 40; // px/s

  function setBrimmMarqueeDurations() {
    const reduce = window.matchMedia
      && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    document.querySelectorAll(".brimm-marquee__track").forEach((track) => {
      if (reduce) { track.style.animationPlayState = "paused"; return; }
      const travel = track.scrollWidth * 0.5; // half the content = one loop's worth
      if (!travel) return;
      // Drive BOTH the shift (px) and the duration from the same measured width, so
      // the keyframe's travel distance and its duration can never disagree (which is
      // what made a constrained track crawl before the flex-shrink:0 fix).
      track.style.setProperty("--marquee-shift", travel + "px");
      track.style.setProperty("--marquee-duration", (travel / BRIMM_MARQUEE_SPEED) + "s");
      track.style.animationPlayState = "";
    });
  }

  // Fonts change text width, so wait for them before the first measure.
  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(setBrimmMarqueeDurations).catch(setBrimmMarqueeDurations);
  } else {
    setBrimmMarqueeDurations();
  }
  window.addEventListener("load", setBrimmMarqueeDurations);

  let brimmMarqueeResizeTimer = null;
  window.addEventListener("resize", () => {
    clearTimeout(brimmMarqueeResizeTimer);
    brimmMarqueeResizeTimer = setTimeout(setBrimmMarqueeDurations, 150);
  });
});
